import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOM_FORMULA } from './schema';

const MUTATION = gql`
  mutation UpdateCustomFormula(
    $id: ID!
    $generationTool: GenerationToolEnum!
    $name: String!
    $body: String!
    $isDefault: Boolean
  ) {
    updateCustomFormula(
      id: $id
      generationTool: $generationTool
      name: $name
      body: $body
      isDefault: $isDefault
    ) {
      ...CustomFormula
    }
  }
  ${FRAGMENT_CUSTOM_FORMULA}
`;

export const updateCustomFormula = ({ id, generationTool, name, body, isDefault }) => {
  const variables = {
    id,
    generationTool,
    name,
    body,
    isDefault,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
